import { render, staticRenderFns } from "./Screens.vue?vue&type=template&id=e8cf2a9c&lang=pug&"
import script from "./Screens.vue?vue&type=script&lang=js&"
export * from "./Screens.vue?vue&type=script&lang=js&"
import style0 from "./Screens.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8cf2a9c')) {
      api.createRecord('e8cf2a9c', component.options)
    } else {
      api.reload('e8cf2a9c', component.options)
    }
    module.hot.accept("./Screens.vue?vue&type=template&id=e8cf2a9c&lang=pug&", function () {
      api.rerender('e8cf2a9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/specific/Screens.vue"
export default component.exports